<template>
    <section>

        <div>
            <h2 class="mt-5">Top Posts
                <select class="form-control tweets-select float-right" v-model="selected">
                    <option v-for="option in options" :key="option.id" :value="option.id">{{option.name}}</option>
                </select>
            </h2>
            <br>
            <div :class="locked" s class="tweets-wrapper">
                <div v-if="posts[selected].length === 0" class="text-muted">
                    <font-awesome-icon :icon="['far', 'frown']"/>  There was not enough comments to calculate this view
                </div>
                <div v-else class="tweets-grid-item" v-for="post in posts[selected]" :key="post">
                    <Post :permalink="post"/>
                </div>
<!--                <div class="unlock-button-wrapper">-->
<!--                    <button @click="unlock" class="unlock btn btn-upgrade btn-large"><i class="fa fa-unlock"></i> Unlock real report for #{{hashtag}}</button>-->
<!--                </div>-->
            </div>
        </div>
    </section>
</template>

<script>
    import Post from './Post'

    export default {
        name: 'Posts',
        components: {Post},
        comments: {
            Post
        },
        props: { // 'locked', 'hashtag'
            posts: {
                default: () => {
                    return {
                        'positive': [],
                        'negative': [],
                        'engagement': [],
                        'impression': [],
                        'likes': [],
                        'comments': []
                    }
                },
                type: Object
            },
            locked: {
                default: true,
                type: Boolean
            },
            hashtag: {
                default: '',
                type: String
            }
        },
        data () {
            return {
                selected: 'engagement',
                options: [
                    {'name': 'Most engagement', 'id': 'engagement'},
                    {'name': 'Most impressions', 'id': 'impressions'},
                    {'name': 'Most likes', 'id': 'likes'},
                    {'name': 'Most comments', 'id': 'comments'},
                    {'name': 'Most positive comments', 'id': 'positive'},
                    {'name': 'Most negative comments', 'id': 'negative'}
                ]
            }
        }
    }
</script>

<style scoped lang="scss">
    .tweets-select {
        display: inline-block;
        width: 200px;
    }
    .tweets-wrapper {
        display: grid;
        grid-gap: 10px;
        grid-template-columns: auto auto auto;
        &.locked {
            .tweets-grid {
                -webkit-filter: grayscale(100%);
                filter: grayscale(100%);
                opacity: 0.4;
                pointer-events: none;
            }
            .unlock-button-wrapper {
                display:block !important;
            }
        }
        .unlock-button-wrapper {
            display:none;
            width:100%;
            position: absolute;
            top: 20%;
            left: 0%;
            text-align: center;
        }
    }
</style>
